import script from "./SearchPanelWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPanelWrapper.vue?vue&type=script&setup=true&lang=js"

import "./SearchPanelWrapper.vue?vue&type=style&index=0&id=2bd90386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd90386"]])

export default __exports__